module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-menu-0efb3936ae384e6f120a03bcfe487126.svg";